import { render, staticRenderFns } from "./OnboardingCard.vue?vue&type=template&id=3e688eac&scoped=true&"
import script from "./OnboardingCard.vue?vue&type=script&lang=ts&"
export * from "./OnboardingCard.vue?vue&type=script&lang=ts&"
import style0 from "./OnboardingCard.vue?vue&type=style&index=0&id=3e688eac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e688eac",
  null
  
)

export default component.exports